const MobileRecognitionScheduleView = () => {
  return 'ScheduleView'
}

export default MobileRecognitionScheduleView
